import Vue from 'vue'
import pluginValue from 'sweetalert2'
const pluginName = '$swal'

const confirmButtonText = '확인'
const cancelButtonText = '취소'

function checkText(option) {
  if (typeof option === 'string') {
    option = {
      text: option,
    }
  }
  return option
}

pluginValue.basic = {
  alert(option) {
    option = checkText(option)
    return pluginValue.fire(
      Object.assign(
        {
          confirmButtonText,
          customClass: {
            container: 'custom-alert__container',
            popup: 'custom-alert__popup',
            content: 'custom-alert__content',
            confirmButton: 'custom-alert__btn alert__btn--ok',
          },
        },
        option,
      ),
    )
  },
  warning(option) {
    option = checkText(option)
    return pluginValue.fire(
      Object.assign(
        {
          icon: 'warning',
          confirmButtonText,
          reverseButtons: true,
          customClass: {
            container: 'custom-alert__container icon-container',
            popup: 'custom-alert__popup',
            content: 'custom-alert__content',
            confirmButton: 'custom-alert__btn alert__btn--ok',
          },
        },
        option,
      ),
    )
  },
  confirm(option) {
    option = checkText(option)
    return pluginValue.fire(
      Object.assign(
        {
          showCancelButton: true,
          confirmButtonText,
          cancelButtonText,
          reverseButtons: true,
          customClass: {
            container: 'custom-alert__container confirm-container',
            popup: 'custom-alert__popup',
            content: 'custom-alert__content',
            confirmButton: 'custom-alert__btn alert__btn--confirm',
            cancelButton: 'custom-alert__btn alert__btn--cancel',
          },
        },
        option,
      ),
    )
  },
  success(option) {
    option = checkText(option)
    return pluginValue.fire(
      Object.assign(
        {
          icon: 'success',
          confirmButtonText,
          reverseButtons: true,
          allowOutsideClick: false,
          customClass: {
            container: 'custom-alert__container icon-container',
            popup: 'custom-alert__popup',
            content: 'custom-alert__content',
            confirmButton: 'custom-alert__btn alert__btn--ok',
          },
        },
        option,
      ),
    )
  },
  error(option) {
    option = checkText(option)
    return pluginValue.fire(
      Object.assign(
        {
          icon: 'error',
          confirmButtonText,
          reverseButtons: true,
          customClass: {
            container: 'custom-alert__container icon-container',
            popup: 'custom-alert__popup',
            content: 'custom-alert__content',
            confirmButton: 'custom-alert__btn alert__btn--ok',
          },
        },
        option,
      ),
    )
  },
  custom(option) {
    option = checkText(option)
    return pluginValue.fire(Object.assign({}, option))
  },
  loading(option) {
    option = checkText(option)
    return pluginValue.fire(
      Object.assign(
        {
          title: '실행중...',
          icon: 'info',
          showConfirmButton: true,
          timerProgressBar: true,
          allowOutsideClick: false,
          didOpen() {
            pluginValue.showLoading()
          },
        },
        option,
      ),
    )
  },
}

const plugin = {
  install(Vue) {
    window[pluginName] = pluginValue
    Vue.prototype[pluginName] = pluginValue
  },
}

Vue.use(plugin)

export default plugin
